import { Box, Checkbox, FormControl, FormControlLabel } from '@material-ui/core';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { Font } from '@/components/shared/components/Font';
import { Icon } from '@/components/shared/components/Icon';
import { StandardButton } from '@/components/shared/components/StandardButton';
import { Text } from '@/components/shared/components/Text';
import { useCustomTheme } from '@/hooks/useCustomTheme';

interface DistributionCheckboxProps {
  name: string;
  labelIcon: string;
  labelTextId: string;
}

export const DistributionCheckbox = ({ name, labelIcon, labelTextId }: DistributionCheckboxProps) => {
  const { palette, customBorderRadius } = useCustomTheme();
  const { setValue, setFocus, getValues, watch } = useFormContext();

  const isActive = watch(name);

  const activeColor = palette.primary.main;

  const buttonStyles = {
    border: '2px solid',
    borderColor: isActive ? activeColor : palette.common.white,
    color: isActive ? activeColor : palette.text.secondary,
    borderRadius: customBorderRadius.paper,
    padding: '16px 0',
    backgroundColor: isActive ? palette.common.white : palette.common.white,
  } as React.CSSProperties;

  const formControlLabelStyles = {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    margin: 0,
  } as React.CSSProperties;

  const checkboxStyles = {
    margin: 0,
    padding: 7,
  } as React.CSSProperties;

  const handleClick = (e) => {
    e.preventDefault();
    setValue(name, !getValues(name));
    setFocus(name);
  };

  return (
    <Controller
      name={name}
      render={({ field }) => (
        <FormControl fullWidth style={{ margin: 0 }}>
          <StandardButton style={buttonStyles} onClick={handleClick}>
            <FormControlLabel
              style={formControlLabelStyles}
              control={<Checkbox checked={field?.value} color={'primary'} style={checkboxStyles} {...field} />}
              label={
                <Box display={'flex'} flexDirection={'column'} gridGap={8}>
                  <Icon>{labelIcon}</Icon>
                  <Font variant={'body2'}>
                    <Text tId={labelTextId} />
                  </Font>
                </Box>
              }
            />
          </StandardButton>
        </FormControl>
      )}
    />
  );
};
